import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from 'react-router-dom';
import Header from 'Components/HeaderPlain';

const DailyReportDistrict = () => {
  const { stateName } = useParams();
  const decodedStateName = decodeURIComponent(stateName);
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReport = async () => {
      console.log('Fetching report data...');
      try {
        const res = await fetch('https://ecoclubs.education.gov.in/api/get-recent-district', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ state: decodedStateName }),
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data = await res.json();
        console.log('Full API response:', data);

        const allStates = data.data.getAllStateAndDistrict;
        console.log('Parsed getAllStateAndDistrict:', allStates);

        const normalizedUrlState = stateName.toUpperCase().replace(/\s+/g, '');
        console.log('Normalized stateName from URL:', normalizedUrlState);

        const matchingStateKey = Object.keys(allStates).find((key) =>
          key.toUpperCase().replace(/\s+/g, '') === normalizedUrlState
        );

        if (matchingStateKey && typeof allStates[matchingStateKey] === 'object') {
          const stateDistrictData = allStates[matchingStateKey];
          console.log('Matching state found:', matchingStateKey);

          const formattedDistricts = Object.entries(stateDistrictData)
            .map(([districtName, values]) => ({
              name: districtName,
              count: values.total || 0,
              last24hrs: values.last24Hours || 0,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)); // Sort alphabetically

          console.log('Formatted districts:', formattedDistricts);
          setDistricts(formattedDistricts);
        } else {
          console.warn('No matching state found for:', normalizedUrlState);
          setDistricts([]);
        }
      } catch (err) {
        console.error('Failed to fetch report data', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [stateName]);

  const totalCount = districts.reduce(
    (acc, district) => {
      acc.total += district.count;
      acc.last24hrs += district.last24hrs;
      return acc;
    },
    { total: 0, last24hrs: 0 }
  );

  if (loading) return <div className="container mt-5">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container mt-5" style={{ paddingBottom: '110px' }}>
        <div className="mt-5">
          <h4>
            Total no. of Schools Onboarded in{' '}
            {stateName.replace(/^\w/, (c) => c.toUpperCase())}
          </h4>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>District Name</th>
                <th className="text-center">No. of Schools Onboarded</th>
                <th className="text-center">Last 24 hrs</th>
              </tr>
            </thead>
            <tbody>
              {districts.length > 0 ? (
                <>
                  {districts.map((district, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{district.name}</td>
                      <td className="text-center">{district.count}</td>
                      <td className="text-center">{district.last24hrs}</td>
                    </tr>
                  ))}
                  <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                    <td colSpan="2" className="text-right">Total</td>
                    <td className="text-center">{totalCount.total}</td>
                    <td className="text-center">{totalCount.last24hrs}</td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No districts found for this state.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default DailyReportDistrict;
